//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'exposito',
    colors: ['#8bc9c3', '#ffae43', '#ea432c', '#228345', '#d1d7d3', '#524e9c', '#9dc35e', '#f0a1a1'],
    stroke: '#fff',
    background: '#000000',
    type: 'exposito',
  },
  {
    name: 'exposito_sub1',
    colors: ['#8bc9c3', '#ffae43', '#ea432c', '#524e9c'],
    stroke: '#fff',
    background: '#000000',
    type: 'exposito',
  },
  {
    name: 'exposito_sub2',
    colors: ['#8bc9c3', '#ffae43', '#ea432c', '#524e9c', '#f0a1a1', '#228345'],
    stroke: '#fff',
    background: '#000000',
    type: 'exposito',
  },
  {
    name: 'exposito_sub3',
    colors: ['#ffae43', '#ea432c', '#524e9c', '#f0a1a1'],
    stroke: '#fff',
    background: '#000000',
    type: 'exposito',
  },
];
